export const wilayah = {
    methods: {
        // provinsi
        onProvinsi (provinsi_id) {
            if (this.wilayah.provinsi) {
                this.$store.dispatch('Wilayah/getKabkota', provinsi_id)
            } else {
                this.$store.commit('Wilayah/kabkota', [])
                this.wilayah = {
                    kabkota: '',
                    kecamatan: ''
                }
                this.form.wilayah_kelurahan_id = ''
            }
        },
        // kabkota
        onKabkota (kabkota_id) {
            if (this.wilayah.kabkota) {
                this.$store.dispatch('Wilayah/getKecamatan', kabkota_id)
            } else {
                this.$store.commit('Wilayah/kecamatan', [])
                this.wilayah = {
                    kecamatan: ''
                }
                this.form.wilayah_kelurahan_id = ''
            }
        },
        // kecamatan
        onKecamatan (kecamatan_id) {
            if (this.wilayah.kecamatan) {
                this.$store.dispatch("Wilayah/getKelurahan", kecamatan_id)
            } else {
                this.$store.commit('Wilayah/kelurahan', [])
                this.form.wilayah_kelurahan_id = ''
            }
        }
    }
}

export default wilayah